export const assertAllFieldsDefined = <T>(obj: Partial<T>): T => obj as T;
